export const WEB_APP_USER = "user"
export const TODAY = "HOY"
export const YERTERDAY = "AYER"